import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Optional right-side content (e.g. "Updated 2m ago" or action buttons) */
  action?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Reusable page header matching the Dashboard Snapshot style:
 * bold title, optional subtitle, optional right-aligned action/status.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { sm: 'center' },
        justifyContent: 'space-between',
        gap: 1.5,
        mb: 2.5,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: 'Lato, sans-serif',
            fontSize: '0.875rem',
            fontWeight: 600,
            lineHeight: 1.25,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.65rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'text.disabled',
              mt: 0.25,
            }}
          >
            {subtitle}
          </Typography>
        )}
        {children}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
};

export default PageHeader;
